export default {"src":"/_next/static/media/consumer.5a943608.svg","height":576,"width":551,"blurWidth":0,"blurHeight":0};